import { ProfileEditFormFields } from '../../../ui/profile-edit/types';
import { required } from '@shared/lib/validation/validateRequired/required';
import { ProfileEditFormKeys } from '../../../config/form-constants';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { validatePhone } from '@shared/lib/validation/validatePhone/validate-phone';

export const validateEditProfile = (fields: ProfileEditFormFields) => {
    const { validateField, errors } = validateForm();
    validateField({
        name: ProfileEditFormKeys.Name,
        message: required(fields[ProfileEditFormKeys.Name]),
    });
    validateField({
        name: ProfileEditFormKeys.Surname,
        message: required(fields[ProfileEditFormKeys.Surname]),
    });
    validateField({
        name: ProfileEditFormKeys.Phone,
        message: validatePhone(fields[ProfileEditFormKeys.Phone]),
    });
    validateField({
        name: ProfileEditFormKeys.JobTitle,
        message: required(fields[ProfileEditFormKeys.JobTitle]),
    });
    validateField({
        name: ProfileEditFormKeys.Department,
        message: required(fields[ProfileEditFormKeys.Department]?.[0]?.value),
    });
    return errors;
};
